module.exports = __webpack_public_path__ + "assets/materials-0ae9ff4bef726c5b3c758fb29cc0fa91.svg";